import { useEffect } from 'react';

import useNotification from '@/hooks/useNotification';
import { getQueryParam } from '@/utils/queryParams';

const useSignUpFlashMessage = () => {
  const { setErrorNotification } = useNotification();
  const flashKey = getQueryParam('flash');

  useEffect(() => {
    switch (flashKey) {
      case 'no-saml-sign-up':
        setErrorNotification('No SSO sign up is in progress.');
        break;
      case 'no-saml-app':
        setErrorNotification('SSO is not enabled for the organization.');
        break;
      default:
        break;
    }
  }, [flashKey, setErrorNotification]);
};

export default useSignUpFlashMessage;
